var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"secondary_site_button",staticClass:"secondary_site_button",class:[_vm.theme, _vm.type],attrs:{"href":_vm.parsedLink ? _vm.parsedLink.url : null,"target":_vm.parsedLink ? _vm.parsedLink.target : null},on:{"mouseenter":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.button_label ? _vm.button_label : _vm.parsedLink.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/SecondaryButton.vue